import { render, staticRenderFns } from "./TeacherPageList.vue?vue&type=template&id=4b7d469b&scoped=true&"
import script from "./TeacherPageList.vue?vue&type=script&lang=js&"
export * from "./TeacherPageList.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPageList.vue?vue&type=style&index=0&id=4b7d469b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d469b",
  null
  
)

export default component.exports